export default __webpack_public_path__ + "static/eup-img-1-0de23cae779b7438bca3f7bf9b9778f9.png";